import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import NewHeroSection from './NewHeroSection'
import TabbedContent from './TabbedContent'
import ContactSection from './ContactSection'
import Footer from 'components/Layout/Footer'

const HomePage = () => {
  // Update document title and meta description for SEO
  useEffect(() => {
    document.title = 'Medical Jobs & Clinician Careers | MyStethi Healthcare Platform'
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]')
    if (!metaDescription) {
      metaDescription = document.createElement('meta')
      metaDescription.name = 'description'
      document.head.appendChild(metaDescription)
    }
    metaDescription.content = 'Find medical jobs and clinician careers with MyStethi. Connect directly with hospitals, browse curated healthcare positions, and advance your medical career. Free platform for healthcare professionals.'
    
    // Add structured data for SEO
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.mystethi.com/#organization",
          "name": "MyStethi",
          "url": "https://www.mystethi.com",
          "description": "MyStethi is a free healthcare job platform connecting medical professionals with hospitals and health systems. Find clinician jobs, medical careers, and healthcare opportunities."
        },
        {
          "@type": "WebSite",
          "@id": "https://www.mystethi.com/#website",
          "url": "https://www.mystethi.com",
          "name": "MyStethi - Medical Jobs & Healthcare Careers",
          "description": "Find medical jobs and clinician careers with MyStethi. Connect directly with hospitals, browse curated healthcare positions, and advance your medical career.",
          "publisher": {
            "@id": "https://www.mystethi.com/#organization"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.mystethi.com/jobs?search={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }
      ]
    }
    
    // Add structured data script
    let structuredDataScript = document.getElementById('homepage-structured-data')
    if (!structuredDataScript) {
      structuredDataScript = document.createElement('script')
      structuredDataScript.id = 'homepage-structured-data'
      structuredDataScript.type = 'application/ld+json'
      document.head.appendChild(structuredDataScript)
    }
    structuredDataScript.textContent = JSON.stringify(structuredData)
    
    // Cleanup function
    return () => {
      // Remove structured data when component unmounts
      const script = document.getElementById('homepage-structured-data')
      if (script) {
        document.head.removeChild(script)
      }
    }
  }, [])

  return (
    <Box component="main" sx={{ width: '100%' }}>
      <NewHeroSection />
      <Box component="section" aria-label="Healthcare job search features">
        <TabbedContent />
      </Box>
      <Box component="section" aria-label="Get started with MyStethi">
        <ContactSection />
      </Box>
      <Footer />
    </Box>
  )
}

export default HomePage
